/* Aliv Peru: funciones globales que el tema espera (antes vivian en este archivo, que quedo vacio). Basado en Dawn. */
(function () {
  var focusSel = "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";
  var trapHandlers = {};

  window.getFocusableElements = window.getFocusableElements || function (container) {
    return Array.from(container.querySelectorAll(focusSel));
  };

  window.removeTrapFocus = window.removeTrapFocus || function (elementToFocus) {
    document.removeEventListener('focusin', trapHandlers.focusin);
    document.removeEventListener('focusout', trapHandlers.focusout);
    document.removeEventListener('keydown', trapHandlers.keydown);
    if (elementToFocus && elementToFocus.focus) elementToFocus.focus();
  };

  window.trapFocus = window.trapFocus || function (container, elementToFocus) {
    if (!container) return;
    elementToFocus = elementToFocus || container;
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
    trapHandlers.focusin = function (event) {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapHandlers.keydown);
    };
    trapHandlers.focusout = function () {
      document.removeEventListener('keydown', trapHandlers.keydown);
    };
    trapHandlers.keydown = function (event) {
      if (event.code && event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };
    document.addEventListener('focusout', trapHandlers.focusout);
    document.addEventListener('focusin', trapHandlers.focusin);
    if (elementToFocus.focus) elementToFocus.focus();
    if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };

  window.onKeyUpEscape = window.onKeyUpEscape || function (event) {
    if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    var openDetails = event.target.closest('details[open]');
    if (!openDetails) return;
    var summary = openDetails.querySelector('summary');
    openDetails.removeAttribute('open');
    summary.setAttribute('aria-expanded', false);
    summary.focus();
  };

  window.pauseAllMedia = window.pauseAllMedia || function () {
    document.querySelectorAll('.js-youtube').forEach(function (v) {
      v.contentWindow && v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach(function (v) {
      v.contentWindow && v.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach(function (v) { v.pause(); });
    document.querySelectorAll('product-model').forEach(function (m) {
      if (m.modelViewerUI) m.modelViewerUI.pause();
    });
  };

  window.debounce = window.debounce || function (fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  };

  window.throttle = window.throttle || function (fn, delay) {
    var last = 0;
    return function () {
      var now = Date.now();
      if (now - last < delay) return;
      last = now;
      return fn.apply(this, arguments);
    };
  };

  window.fetchConfig = window.fetchConfig || function (type) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/' + (type || 'json') }
    };
  };

  window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || { cartUpdate: 'cart-update', quantityUpdate: 'quantity-update', variantChange: 'variant-change', cartError: 'cart-error' };
  var subscribers = {};
  window.subscribe = window.subscribe || function (eventName, callback) {
    (subscribers[eventName] = subscribers[eventName] || []).push(callback);
    return function () {
      subscribers[eventName] = subscribers[eventName].filter(function (cb) { return cb !== callback; });
    };
  };
  window.publish = window.publish || function (eventName, data) {
    (subscribers[eventName] || []).forEach(function (cb) { cb(data); });
  };

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', class extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        if (!this.input) return;
        this.changeEvent = new Event('change', { bubbles: true });
        this.querySelectorAll('button').forEach((button) =>
          button.addEventListener('click', this.onButtonClick.bind(this))
        );
      }
      onButtonClick(event) {
        event.preventDefault();
        var previous = this.input.value;
        if (event.currentTarget.name === 'plus') this.input.stepUp();
        else this.input.stepDown();
        if (previous !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    });
  }
})();
